export const getAuthHeaders = (): HeadersInit => {
    const token = localStorage.getItem("journey_token");

    return {
        "Content-Type": "application/json",

        ...(token
            ? {
                Authorization: `Bearer ${token}`,
            }
            : {}),
    };
};